export interface PricingConfig {
  vatRate: number;
  baseDeliveryFee: number;
  freeDeliveryThreshold: number;
}

export interface PricingSettingsSource {
  delivery_fee?: string | null;
  free_delivery_threshold?: string | null;
  vat_rate?: string | null;
}

export const DEFAULT_PRICING_CONFIG: PricingConfig = {
  vatRate: 0,
  baseDeliveryFee: 0,
  freeDeliveryThreshold: 0,
};

function parseNumber(value: string | null | undefined): number {
  if (!value) {
    return 0;
  }

  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function resolvePricingConfig(settings?: PricingSettingsSource | null): PricingConfig {
  if (!settings) {
    return DEFAULT_PRICING_CONFIG;
  }

  return {
    vatRate: parseNumber(settings.vat_rate),
    baseDeliveryFee: parseNumber(settings.delivery_fee),
    freeDeliveryThreshold: parseNumber(settings.free_delivery_threshold),
  };
}
